exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ca-failure-reasons{list-style-type:decimal;list-style-position:inside;margin-bottom:20px}.step-3-failure-error-container{text-align:center;padding-left:15px;padding-right:15px}@media (min-width:768px){.step-3-failure-error-container{text-align:left}}.step-3-failure-error-container p{text-align:center;width:100%;color:#d90000;margin-top:8px;margin-bottom:32px}@media (min-width:768px){.step-3-failure-error-container p{text-align:left}}.step-3-failure-error-container #switch-to-open-term-button,.step-3-failure-error-container #try-again-button{margin-right:4px;margin-left:4px}.step-3-failure-error-container a,.step-3-failure-error-container button{width:262px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/CreditAssessmentStep3Failure/CreditAssessmentStep3Failure.scss
 ** module id = 1228
 ** module chunks = 0
 **/